import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { AuthContext } from "../../shared/context/auth-context";
import Card from "../../shared/components/UIElements/Card";
import Button from "../../shared/components/formElements/Button";
import Modal from "../../shared/components/UIElements/Modal";
import { useHttpClient } from "../../shared/hooks/http-hook";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import { dateHandler } from "./SpecialOrders";
import "./SpecialOrderInfo.css";
import { ITEM_TYPES } from "../../item/components/itemTypes";
import { formatPhoneNumber } from "../../print/page/Print";
import { useWindow } from "../../shared/hooks/window-hook";

const SpecialOrderInfo = () => {
  const { width } = useWindow();
  const auth = useContext(AuthContext);
  const [isPrint, setIsPrint] = useState(true)
  const history = useHistory();
  const [showConfirmModal, setShowConfirmModal] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [loadedSpecialOrder, setLoadedSpecialOrder] = useState({
    orderNumber: "",
    style: "",
    company: "",
    color: "",
    USSize: "",
    customer: [""],
    startDate: "",
    eventDate: "",
    arrivalDate: "",
    paymentStatus: "",
    location: "",
    archive: "",
  });

  const specialOrderID = useParams().specialOrderId;
  useEffect(() => {
    const fetchSpecialOrder = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL +
            `/specialOrders/${specialOrderID}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token }
        );
        setLoadedSpecialOrder(responseData.specialOrder);
      } catch (err) {}
    };
    fetchSpecialOrder();
  }, [sendRequest, specialOrderID, auth.token]);

  const showWarningHandler = (task) => {
    setShowConfirmModal(task);
  };
  const cancelWarningHandler = () => {
    setShowConfirmModal("");
  };

  const confirmDeleteHandler = async () => {
    setShowConfirmModal("");
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + `/specialOrders/${specialOrderID}`,
        "DELETE",
        null,
        { Authorization: "Bearer " + auth.token }
      );
      history.push("/specialOrders");
    } catch (err) {}
  };

  const confirmArchiveHandler = async () => {
    setShowConfirmModal("");
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL +
          `/specialOrders/${specialOrderID}/archive`,
        "PATCH",
        JSON.stringify({
          archive: loadedSpecialOrder.archive,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      history.push("/specialOrders");
    } catch (err) {}
  };

  const confirmMoveHandler = async () => {
    setShowConfirmModal("");
    let responseData;
    try {
      responseData = await sendRequest(
        process.env.REACT_APP_BACKEND_URL + "/items/new",

        "POST",
        JSON.stringify({
          style: loadedSpecialOrder.style + uuidv4(),
          company: loadedSpecialOrder.company
            ? loadedSpecialOrder.company
            : "NONE",
          color: loadedSpecialOrder.color ? loadedSpecialOrder.color : "NONE",
          USSize: loadedSpecialOrder.USSize,
          EURSize: loadedSpecialOrder.USSize,
          quantity: 1,
          cost: loadedSpecialOrder.cost,
          price: loadedSpecialOrder.price,
          website: " ",
          type: ITEM_TYPES.SPECIAL,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      history.push("/orders/new");
    } catch (err) {
      return;
    }
    // if (responseData) {
    //   try {
    //     await sendRequest(
    //       process.env.REACT_APP_BACKEND_URL +
    //         `/specialOrders/${specialOrderID}/archive`,
    //       "PATCH",
    //       JSON.stringify({
    //         // style: loadedSpecialOrder.style + " MOVED",
    //         archive: loadedSpecialOrder.archive,
    //       }),
    //       {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer " + auth.token,
    //       }
    //     );
    //     history.push("/orders/new");
    //   } catch (err) {}
    // }
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <Modal
        show={showConfirmModal}
        onCancel={cancelWarningHandler}
        header="Are you sure?"
        footerClass="specialOrders-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelWarningHandler}>
              CANCEL
            </Button>
            {showConfirmModal === "SALE" ? (
              <Button success onClick={confirmMoveHandler}>
                SALE
              </Button>
            ) : showConfirmModal === "DELETE" ? (
              <Button danger onClick={confirmDeleteHandler}>
                DELETE
              </Button>
            ) : (
              <Button secondary onClick={confirmArchiveHandler}>
                ARCHIVE
              </Button>
            )}
          </React.Fragment>
        }
      >
        <p>
          {` Do you want to proceed and ${showConfirmModal.toLowerCase()} this special Order? Please note that it can't
          be undone thereafter.`}
        </p>
      </Modal>

      {!isLoading && loadedSpecialOrder && (
        <li className="specialOrder-info-list ">
          <Card className="specialOrders-item__content">
            <div className="container">
              <form>
                <div className="flex justify-between">
                  <div className=" w-25 ">
                    {loadedSpecialOrder.archive === false ? "" : "Archive: 📁"}
                  </div>
                  <div className=" w-50 sp-header">
                    <h2>Special Order Details</h2>
                  </div>
                  <div className=" w-25 " style={{ textAlign: "right" }}>                   
                  {isPrint ? 
                    <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint);}}>                
                      PRINT
                    </Button> :
                    <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint); window.print();setIsPrint(!isPrint);}}>                
                      🖨️
                    </Button>}
                  </div>
                </div>

                <div className="flex justify-center">
                  <div className=" w-50 mr1 tl">
                    <label> Order Number</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedSpecialOrder.orderNumber}
                    />
                  </div>
                  <div className="w-50  tl  mr1">
                    <label>Style</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedSpecialOrder.style.split("_")[0]}
                    />
                  </div>
                </div>
                <div className="flex justify-center">
                  <div className=" w-33 tl mr1">
                    <label>Name</label>
                    <input
                      readOnly
                      type="text"
                      value={
                        loadedSpecialOrder.customer.flat()[0]
                          ? loadedSpecialOrder.customer.flat()[0].name
                          : "N/A"
                      }
                    />
                  </div>
                  <div className=" w-33 tl mr1">
                    <label>Last name</label>
                    <input
                      readOnly
                      type="text"
                      value={
                        loadedSpecialOrder.customer.flat()[0]
                          ? loadedSpecialOrder.customer.flat()[0].lastname
                          : "N/A"
                      }
                    />
                  </div>
                  <div className=" w-33 tl mr1">
                    <label>Phone</label>
                    <input
                      readOnly
                      type="text"
                      value={
                        loadedSpecialOrder.customer.flat()[0]
                          ? formatPhoneNumber(loadedSpecialOrder.customer.flat()[0].phone)
                          : "N/A"
                      }
                    />
                  </div>
                </div>
                <div className="flex justify-center">
                  <div className=" w-33 tl mr1">
                    <label>Company</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedSpecialOrder.company}
                    />
                  </div>

                  <div className=" w-33 tl mr1">
                    <label>Color</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedSpecialOrder.color}
                    />
                  </div>
                  <div className=" w-33 tl mr1">
                    <label>US Size</label>
                    <input
                      readOnly
                      type="text"
                      value={loadedSpecialOrder.USSize}
                    />
                  </div>
                </div>

                <div className="flex justify-around">
                  <div className=" w-33 tl mr1">
                    <label>Order Date</label>
                    <input
                      readOnly
                      type="text"
                      value={
                        loadedSpecialOrder.startDate
                          ? dateHandler(loadedSpecialOrder.startDate)
                          : "N/A"
                      }
                    />
                  </div>
                  {isPrint && <div className=" w-33 tl mr1">
                    <label>Arrival Date</label>
                    <input
                      readOnly
                      type="text"
                      value={
                        loadedSpecialOrder.arrivalDate
                          ? dateHandler(loadedSpecialOrder.arrivalDate)
                          : "N/A"
                      }
                    />
                  </div>}
                  <div className=" w-33 tl mr1">
                    <label>Event Date</label>
                    <input
                      readOnly
                      type="text"
                      value={
                        loadedSpecialOrder.eventDate
                          ? dateHandler(loadedSpecialOrder.eventDate)
                          : "N/A"
                      }
                    />
                  </div>
                </div>

                <div className="flex justify-around">
                  <div className=" w-33 tl mr1">
                    <label>Location</label>
                    <input readOnly type="text" value={loadedSpecialOrder.location} />
                  </div>
                  {isPrint && <div className=" w-33 tl mr1">
                    <label>Cost</label>
                    <input readOnly type="text" value={"$" + loadedSpecialOrder.cost} />
                  </div>}
                  <div className=" w-33 tl mr1">
                    <label>Price</label>
                    <input readOnly type="text" value={"$" + loadedSpecialOrder.price} />
                  </div>
                </div>
              </form>
            </div>

             {isPrint && <div className="specialOrders-item__actions">
              <Button inverse to="/specialOrders">
                BACK
              </Button>
              <Button to={`/specialOrders/${specialOrderID}/edit`}>EDIT</Button>
              {width >800 && loadedSpecialOrder.archive === false && <Button success onClick={() => showWarningHandler("SALE")}>
                SALE
              </Button>}
              <Button danger onClick={() => showWarningHandler("DELETE")}>
                DELETE
              </Button>
              <Button secondary onClick={() => showWarningHandler("ARCHIVE")}>
                {loadedSpecialOrder.archive ? "UNARCHIVE" : "ARCHIVE"}
              </Button>
            </div>}
          </Card>
          </li>
      )}
      {isPrint && <FloatingButton icon={"back"} />}
    </React.Fragment>
  );
};

export default SpecialOrderInfo;
